import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserLocalStorageKey } from '../../model/key/user';
import { defaultErrorMessage } from '../../model/key/variable.key';
import { LocalStorageService } from '../localstorage/localStorage.service';
import { LoginApiService } from '../service/login.api.service';
import { ToastService } from '../toast/toast.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(private apiService: LoginApiService, private localStorageService: LocalStorageService, private toastService: ToastService) {
  }

  public isLoggedIn(): boolean {
    let user = this.localStorageService.getUserDetails()
    return user ? true : false;
  }

  public login(user) {
    return this.apiService.guestUserLogin(user).pipe(map((response) => {
      this.postLoginTask(response);
      return response;
    }), catchError((error) => { return throwError(error) }));
  }

  public getNewAccessToken(): Observable<any> {
    return this.login({});
  }

  private postLoginTask(accountUser: any) {
    if (accountUser && JSON.parse(accountUser.isFinalLogin)) {
      let { roles, name, userProfileUrl } = accountUser;
      this.localStorageService.set(UserLocalStorageKey.User, { roles, name, userProfileUrl });
      this.setNewAccessTokenInfo(accountUser);
    }
    else {
      this.toastService.openToast(defaultErrorMessage);
    }
  }

  public logout(): void {
    this.apiService.logout().subscribe(() => {
      this.postLogoutAction()
    }, () => {
      this.postLogoutAction()
    });
  }

  private postLogoutAction() {
    this.clearLoggedInDetails();
    document.location.reload();
  }

  private clearLoggedInDetails() {
    this.localStorageService.remove(UserLocalStorageKey.User);
    this.localStorageService.remove(UserLocalStorageKey.UserConfig);
    this.localStorageService.remove(UserLocalStorageKey.TokenExpired);
    this.localStorageService.remove(UserLocalStorageKey.ExpiresIn);
  }

  private setNewAccessTokenInfo(accountUser) {
    this.setExpirationTime(accountUser.expires_in);
    this.localStorageService.remove(UserLocalStorageKey.TokenExpired);
  }

  private setExpirationTime(seconds) {
    let date = new Date();
    date.setSeconds(date.getSeconds() + JSON.parse(seconds) - 60);
    this.localStorageService.set(UserLocalStorageKey.ExpiresIn, date);
  }
}
